var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"riseup-header"},[_c('div',{staticClass:"right-nav"},[(!_vm.isContentLoading)?_vm._t("default"):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"logo"},[_c('img',{staticClass:"riseup-logo",attrs:{"src":_vm.logoUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }